import { useEffect, useMemo, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { ehLogistica } from '../helpers/perfilLogistica';
import api from '../service/api';

export interface FilialPermitida {
  empresa_id: string;
  filial?: string;
  fantasia?: string;
  razao_social?: string;
}

/**
 * Para os demais perfis, `filiais` é null (sem restrição adicional).
 * Para Logística, devolve somente os vínculos de usuarios-filial. Em caso de
 * falha devolve uma lista vazia, evitando liberar todas as empresas por engano.
 */
export const useFiliaisPermitidas = () => {
  const { user } = useAuth();
  const logistica = ehLogistica(user);
  const [filiais, setFiliais] = useState<FilialPermitida[] | null>(
    logistica ? [] : null
  );
  const [carregando, setCarregando] = useState(logistica);

  useEffect(() => {
    if (!logistica) {
      setFiliais(null);
      setCarregando(false);
      return;
    }

    let ativo = true;
    setCarregando(true);
    api
      .get(`/api-essencial/v1/usuarios-filial/${user.id}`)
      .then(({ data }) => {
        if (!ativo) return;
        const empresas = (Array.isArray(data) ? data : [])
          .map((vinculo: any) => vinculo?.empresas)
          .filter((empresa: any) => empresa?.empresa_id && !empresa?.excluido);
        setFiliais(empresas);
      })
      .catch(() => {
        if (ativo) setFiliais([]);
      })
      .finally(() => {
        if (ativo) setCarregando(false);
      });

    return () => {
      ativo = false;
    };
  }, [logistica, user.id]);

  const ids = useMemo(
    () => (filiais ? filiais.map((empresa) => empresa.empresa_id) : null),
    [filiais]
  );
  const codigos = useMemo(
    () =>
      filiais
        ? filiais.map((empresa) => String(empresa.filial || '').trim()).filter(Boolean)
        : null,
    [filiais]
  );

  return { filiais, ids, codigos, carregando, logistica };
};
